// return a selector function to use in wlmForm or wlmList that will reference the specific field
export const selectField = (fieldName: string | number) => (state: { wlm: { [x: string]: any } }) =>
    state.wlm[fieldName]
